import posthog from 'posthog-js';

export function getActiveFeatureFlagVariant<T extends string>(
  flagKey: string,
  enumType: Record<string, T>
): T | null {
  const variant = posthog.getFeatureFlag(flagKey, { send_event: true });

  return Object.values(enumType).includes(variant as T) ? (variant as T) : null;
}
